import React, { Fragment, PureComponent } from 'react';
import PropTypes from 'prop-types';
import { IntlProvider } from 'react-intl';
import { Provider as ReduxProvider } from 'react-redux';
import { createPath } from 'history';

// import ar from 'react-intl/locale-data/ar';
// import bn from 'react-intl/locale-data/bn';
// import en from 'react-intl/locale-data/en';
// import es from 'react-intl/locale-data/es';
// import fr from 'react-intl/locale-data/fr';
// import ko from 'react-intl/locale-data/ko';
// import ru from 'react-intl/locale-data/ru';
// import ur from 'react-intl/locale-data/ur';
// import zh from 'react-intl/locale-data/zh';
// import sq from 'react-intl/locale-data/sq';
// import uk from 'react-intl/locale-data/uk';
// import uz from 'react-intl/locale-data/uz';

const ht = {
  locale: 'ht',
  pluralRuleFunction(e, t) {
    return t && e === 1 ? 'one' : 'other';
  },
};

// zh.js handle basic tranlations relation stuff and there is no separate file for chinese simplified/traditional
// in this case, use only zh file
// addLocaleData([...ar, ...bn, ...en, ...es, ...fr, ht, ...ko, ...ru, ...ur, ...zh, ...sq, ...uk, ...uz]);

const ContextType = {
  dir: PropTypes.string.isRequired,
  // Enables critical path CSS rendering
  // https://github.com/kriasoft/isomorphic-style-loader
  insertCss: PropTypes.func.isRequired,
  // Universal HTTP client
  fetch: PropTypes.func.isRequired,
  fetchExternal: PropTypes.func.isRequired,
  pathname: PropTypes.string.isRequired,
  query: PropTypes.object,
  locale: PropTypes.string,
};

/**
 * The top-level React component setting context (global) variables
 * that can be accessed from all the child components.
 *
 * https://facebook.github.io/react/docs/context.html
 *
 * Usage example:
 *
 *   const context = {
 *     history: createBrowserHistory(),
 *     store: createStore(),
 *   };
 *
 *   ReactDOM.render(
 *     <App context={context}>
 *       <Layout>
 *         <LandingPage />
 *       </Layout>
 *     </App>,
 *     container,
 *   );
 */
class App extends PureComponent {
  static propTypes = {
    context: PropTypes.shape(ContextType).isRequired,
    children: PropTypes.element.isRequired,
  };

  // NOTE: If you need to add or modify header, footer etc. of the app,
  // please do that inside the Layout component.
  render = () => <Fragment>{this.props.children}</Fragment>;
}

export default App;
